<offline-notice>
</offline-notice>

<progress-overlay #progressOverlay>
</progress-overlay>

<div class="pap-mat-primary productdesigner"
     *ngIf="productDesignerService.config">
  <progress-navigation></progress-navigation>

  <div class="productdesigner-step"
       *ngIf="!disableDesigner && currentProduct"
       [ngSwitch]="progress.group">
    <div *ngSwitchCase="progressConstants.GROUP_COLLAGEDESIGNER">
      <collage-designer [designStepId]="progress.groupMember">
      </collage-designer>
    </div>

    <div *ngSwitchCase="progressConstants.GROUP_FEATURES">
      <feature-selection [featureGroupId]="progress.groupMember">
      </feature-selection>
    </div>

    <div *ngSwitchCase="progressConstants.GROUP_ADDITIONAL_PRODUCTS">
      <additional-products-selection></additional-products-selection>
    </div>
  </div>
</div>

<error></error>



// WEBPACK FOOTER //
// ./src/app/product-designer.component.html